import React from 'react';

import Skeleton from '@atlaskit/skeleton';

export const SingleSelectUserPickerFieldSkeleton = (): React.JSX.Element => {
	return (
		<Skeleton
			testId="single-select-user-picker-field-skeleton"
			width="250px"
			height="16px"
			isShimmering
		/>
	);
};
